/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DuplicatePlaceholderAllocationInput = {
    id?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type duplicatePlaceholderAllocationMutationVariables = {
    input: DuplicatePlaceholderAllocationInput;
};
export type duplicatePlaceholderAllocationMutationResponse = {
    readonly duplicatePlaceholderAllocation: {
        readonly placeholderAllocation: {
            readonly node: {
                readonly id: string;
                readonly startDate: string | null;
                readonly endDate: string | null;
                readonly monday: number | null;
                readonly tuesday: number | null;
                readonly wednesday: number | null;
                readonly thursday: number | null;
                readonly friday: number | null;
                readonly saturday: number | null;
                readonly sunday: number | null;
                readonly description: string | null;
                readonly placeholder: {
                    readonly id: string;
                } | null;
            } | null;
        } | null;
    } | null;
};
export type duplicatePlaceholderAllocationMutation = {
    readonly response: duplicatePlaceholderAllocationMutationResponse;
    readonly variables: duplicatePlaceholderAllocationMutationVariables;
};



/*
mutation duplicatePlaceholderAllocationMutation(
  $input: DuplicatePlaceholderAllocationInput!
) {
  duplicatePlaceholderAllocation(input: $input) {
    placeholderAllocation {
      node {
        id
        startDate
        endDate
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        description
        placeholder {
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DuplicatePlaceholderAllocationInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DuplicatePlaceholderAllocationPayload",
    "kind": "LinkedField",
    "name": "duplicatePlaceholderAllocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlaceholderAllocationTypeEdge",
        "kind": "LinkedField",
        "name": "placeholderAllocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlaceholderAllocation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sunday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Placeholder",
                "kind": "LinkedField",
                "name": "placeholder",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "duplicatePlaceholderAllocationMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "duplicatePlaceholderAllocationMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "duplicatePlaceholderAllocationMutation",
    "operationKind": "mutation",
    "text": "mutation duplicatePlaceholderAllocationMutation(\n  $input: DuplicatePlaceholderAllocationInput!\n) {\n  duplicatePlaceholderAllocation(input: $input) {\n    placeholderAllocation {\n      node {\n        id\n        startDate\n        endDate\n        monday\n        tuesday\n        wednesday\n        thursday\n        friday\n        saturday\n        sunday\n        description\n        placeholder {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'dfacd25a23ebf9be0ddd45025828ca19';
export default node;
